/**
 * アルバム管理ボタンディレクティブ
 *
 * アルバムの公開状態管理と各種操作（公開、下書き保存、複製、削除）を提供するコンポーネント
 *
 * 使用例:
 * <album-management-buttons
 *   data="ev.topics"
 *   system="system"
 *   writable="writable"
 *   permittable="permittable"
 *   update-function="update"
 *   copy-function="copy"
 *   delete-function="delete"
 *   is-buttons-disabled="isButtonsDisabled">
 * </album-management-buttons>
 *
 * @param {Object} data - topicsテーブルのアルバムデータ（id, permission_id等を使用）
 * @param {Object} system - システム定数（PERMISSION_APPROVED, PERMISSION_DRAFT等）
 * @param {Boolean} writable - 編集権限の有無
 * @param {Boolean} permittable - 承認権限の有無
 * @param {Function} updateFunction - 公開/下書き保存時のコールバック
 * @param {Function} copyFunction - 複製時のコールバック
 * @param {Function} deleteFunction - 削除時のコールバック
 * @param {Boolean} isButtonsDisabled - ボタン無効化フラグ（連打防止用）
 */

angular.module('inspinia').directive('albumManagementButtons', function () {
  return {
    restrict: 'E',
    scope: {
      data: '=?',
      system: '=?',
      writable: '=?',
      permittable: '=?',
      updateFunction: '=?',
      copyFunction: '=?',
      deleteFunction: '=?',
      isButtonsDisabled: '=?',
    },
    templateUrl: '/manage/src/view/directive/project/album/album_management_buttons.html?' + new Date().getTime(),
    controller: function ($scope, $modal, serverService, $element) {
      /**
       * メニューの表示状態管理
       */
      $scope.isMenuOpen = false;

      /**
       * メニューの表示/非表示を切り替え
       */
      $scope.toggleMenu = function () {
        $scope.isMenuOpen = !$scope.isMenuOpen;
      };

      /**
       * メニュー外クリック検出
       */
      const handleClickOutside = function (event) {
        const dropdownElement = $element[0].querySelector('.albumDropdownMenu');
        const toggleButton = $element[0].querySelector('.albumMenuToggleButton');

        if (
          dropdownElement &&
          toggleButton &&
          !dropdownElement.contains(event.target) &&
          !toggleButton.contains(event.target)
        ) {
          $scope.$apply(function () {
            $scope.isMenuOpen = false;
          });
        }
      };

      /**
       * メニューの開閉を監視
       */
      $scope.$watch('isMenuOpen', function (newValue, oldValue) {
        if (oldValue === newValue) return;
        if (newValue) {
          // メニューが開いた時にイベントリスナーを追加
          // captureフェーズで処理するためtrueを指定
          document.addEventListener('click', handleClickOutside, true);
        } else {
          // メニューが閉じた時にイベントリスナーを削除
          document.removeEventListener('click', handleClickOutside, true);
        }
      });

      /**
       * コンポーネント破棄時のクリーンアップ
       */
      $scope.$on('$destroy', function () {
        document.removeEventListener('click', handleClickOutside, true);
      });

      /**
       * メニューアイテムクリック時の処理
       * イベント伝播を停止してメニューを閉じる
       * ボタンが無効化されている場合はコールバックを実行しない
       */
      $scope.handleMenuItemClick = function (callback, event) {
        if (event) {
          event.stopPropagation();
        }
        $scope.isMenuOpen = false;

        // ボタンが無効化されている場合は処理しない
        if ($scope.isButtonsDisabled) {
          return;
        }

        if (typeof callback === 'function') {
          callback();
        }
      };

      /**
       * 現在のステップを判定
       * @returns {string} step1-4のいずれか
       */
      $scope.step = function () {
        if (!$scope.data || !$scope.data.id || !$scope.data.permission_id) {
          // 未作成
          return 'step1';
        } else if ($scope.data.permission_id == $scope.system.PERMISSION_DRAFT) {
          // 下書き
          return 'step2';
        } else if ($scope.data.permission_id == $scope.system.PERMISSION_PENDING) {
          // 申請中（アルバムでは使用しないが互換性のため残す）
          return 'step3';
        } else if ($scope.data.permission_id == $scope.system.PERMISSION_APPROVED) {
          // 公開済み
          return 'step4';
        }
        // データがない時
        return 'step1';
      };

      /**
       * 複製ボタンの表示判定
       */
      $scope.showCopyButton = function () {
        return typeof $scope.copyFunction == 'function';
      };

      /**
       * 削除ボタンの表示判定
       */
      $scope.showDeleteButton = function () {
        return typeof $scope.deleteFunction == 'function';
      };

      /**
       * アルバム削除確認ダイアログ
       * お気に入りやカートの写真も削除される警告を表示
       */
      $scope.deleteConfirm = function () {
        if (typeof $scope.deleteFunction == 'function') {
          var title = '削除確認';

          // アルバム特有の削除警告メッセージ
          var message = '';
          message += '<strong class="text-danger">！！！削除される前にご確認ください！！！</strong><br/>';
          message += '<br/>';
          message +=
            'アルバムを削除すると、<strong>保護者アプリでお気に入りに登録されている写真や、カートに入れていた写真も削除され、復旧することができません。</strong><br/>';
          message += '本当に削除してよろしいですか？<br/>';
          message += '<br/>';
          message +=
            '※アルバムを非公開にしたい場合、<strong>削除するのではなく「公開期限」に過去の日付を入力して下さい。</strong><br/>';
          message += '<br/>';
          message += '<img src="/manage/img/alert/album_delete.png" width="70%" alt="アルバム削除の警告画像">';

          var callback = function () {
            $scope.deleteFunction();
          };

          serverService.confirm($scope, $modal, title, message, callback, null, serverService.DELETE_CONFIRM_OPTIONS);
        }
      };
    },
  };
});
